import React, { FC, useState } from 'react';
import Container from '../../../../../Common/Container/Container';
import MasonryWrapper from '../../../../../Common/MasonryWrapper/MasonryWrapper';
import { IPicture } from '../../../../../../interfaces/professional/Professional';
import * as classes from './PicturesSection.module.scss';
import { PicturesSectionProps } from '../../../../../Sections/Gallery/PicturesSection/PicturesSection';
import GalleryPictureItem from '../../../../../Common/GalleryPictureItem/GalleryPictureItem';
import LightBoxWrapper from '../../../../DefaultTemplate/Components/LightBoxWrapper/LightBoxWrapper';

const PicturesSection: FC<PicturesSectionProps> = ({ pictures }) => {
  const picturesMapper = (item: IPicture, index: number) => (
    <div onClick={() => pictureClickHandler(index)} key={index}>
      <GalleryPictureItem image={item.url} description={item.description} rounded />
    </div>
  );
  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);
  const [currentPictureIndex, setCurrentPictureIndex] = useState(0);

  const pictureClickHandler = (index: number) => {
    setIsLightBoxOpen(true);
    setCurrentPictureIndex(index);
  };

  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <Container>
        <MasonryWrapper>{pictures.map(picturesMapper)}</MasonryWrapper>
        <LightBoxWrapper
          isOpen={isLightBoxOpen}
          pictures={pictures}
          onClose={() => setIsLightBoxOpen(false)}
          photoIndex={currentPictureIndex}
          onMove={setCurrentPictureIndex}
        />
      </Container>
    </section>
  );
};

export default PicturesSection;
